var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2859 35.4803V4.96729H0.709629V44.7051H33.3514L43.2859 35.4803Z",
    fill: "#7CAF92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2859 31.2227V0.709717H0.709629V40.4476H33.3514L43.2859 31.2227Z",
    fill: "#FFF4E3",
    stroke: "white",
    strokeWidth: 1.41921
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6003 19.7347V22.1129H26.8691V24.491H29.2473V22.1129H31.6254V19.7347H29.2473V17.3566H26.8691V19.7347H12.6003ZM24.491 14.9785H26.8691V17.3566H24.491V14.9785ZM24.491 14.9785H22.1129V12.6003H24.491V14.9785ZM24.491 26.8691H26.8691V24.491H24.491V26.8691ZM24.491 26.8691H22.1129V29.2473H24.491V26.8691Z",
    fill: "#4F6F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext1);
export default __webpack_public_path__ + "static/media/next-1.5032e8d46af93d3325a08fd11385db3b.svg";
export { ForwardRef as ReactComponent };